(function () {
  if (window.__kbuInit) return;
  window.__kbuInit = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('select[data-kbu-select]');
    if (!s) return;
    var o = s.options[s.selectedIndex];
    var img = s.closest('[data-kbu]').querySelector('[data-kbu-img]');
    if (img && o.dataset.img) img.src = o.dataset.img;
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kbu-add]');
    if (!b) return;
    e.preventDefault();
    var box = b.closest('[data-kbu]');
    var id = parseInt(box.querySelector('[data-kbu-select]').value, 10);
    var msg = box.querySelector('[data-kbu-msg]');
    var drawer = document.querySelector('cart-drawer');
    b.setAttribute('aria-busy', 'true');
    msg.textContent = '';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Fehler');
          return d;
        });
      })
      .then(function (d) {
        if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
        if (drawer && typeof drawer.renderContents === 'function' && d.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: id, sections: d.sections });
        } else {
          msg.textContent = 'Liegt im Warenkorb';
        }
      })
      .catch(function (err) { msg.textContent = (err && err.message) || 'Konnte nicht hinzugefügt werden.'; })
      .finally(function () { b.removeAttribute('aria-busy'); });
  });

  /* Wunschset im Warenkorb entfernen (alle Zeilen des Sets) und Set-Code anpassen */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-set-remove]');
    if (!b) return;
    e.preventDefault();
    var upd = {};
    b.dataset.setRemove.split(',').forEach(function (k) { if (k) upd[k] = 0; });
    var row = b.closest('tr');
    if (row) row.style.opacity = '.4';
    var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    function ok(r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Fehler'); return d; }); }
    fetch(root + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: upd }) })
      .then(ok)
      .then(function (cart) {
        var best = 0;
        cart.items.forEach(function (i) { var z = parseInt(i.properties && i.properties._set_size, 10) || 0; if (z > best) best = z; });
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { return !/^WUNSCHSET/i.test(c); });
        if (best) codes.push('WUNSCHSET' + best);
        return fetch(root + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ discount: codes.join(','), sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) }).then(ok);
      })
      .then(function (d) {
        var drawer = document.querySelector('cart-drawer');
        if (!/\/cart\/?$/.test(window.location.pathname) && drawer && typeof drawer.renderContents === 'function' && d.sections) {
          drawer.classList.toggle('is-empty', d.item_count === 0);
          drawer.renderContents({ id: null, sections: d.sections });
        } else {
          window.location.reload();
        }
      })
      .catch(function () { window.location.reload(); });
  });
})();
